"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = Overlay;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactPopper = require("react-popper");
var _OverlayLayer = _interopRequireDefault(require("./OverlayLayer"));
/**
 * 为定位元素创建一个覆盖层
 *
 * @example
 *
  ```js
  const [visible, setVisible] = useState(false);
  const open = () => setVisible(true);
  const close = () => setVisible(false);
  <Overlay
    layers={[
      <Overlay.Layer
        visible={visible}
        content={<div>我是浮层内容，<a onClick={close}>关闭</a></div>}
      />
    ]}
    children={ref => <a ref={ref} onClick={open}>点击弹出浮层</a>}
  />
  ```
 */
function Overlay(_ref) {
  var children = _ref.children,
    layers = _ref.layers;
  return /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    return children(ref);
  }), layers);
}
Overlay.Layer = _OverlayLayer.default;
var _default = exports.default = Overlay;